module.exports = __webpack_public_path__ + "front/img/bj.b90f5c33.png";